import Base from "../utils/base.js";
import Storage from "../utils/storage.js";
import generalMethod from "../utils/generalMethod.js";
import SyModel from "../models/sy.js";
import Report from "../utils/report";

/*
 *@description: 暴露方法（研发对接）
 *@author: 赖雪婷
 *@date: 2022-04-22 16:36:29
*/
import { RSSign } from "./sign.js";
import SdkModel from "../models/sdk";

// 下单来源
const ORDER_SOURCE = 55  //港台页游

const RastarSdk = {
    // 下单
    myfunction(arr) {
        window.location.href = arr;
    },
    createOrder(payInfo, urlData, apiUrl) {
        console.log("研发传的参数payInfo=====", payInfo);
        let isCache = Storage.localStorageGet("deviceIdUa");
        if (!isCache) {
            // 不存在就强制刷新页面
            console.log("deviceIdUa isCache不存在");
            location.reload();
        } else {
            return new Promise((resolve) => {
                generalMethod
                    .freezetoken(
                        urlData.pid,
                        urlData.appid,
                        urlData.md_id
                    )
                    .then((res) => {
                        if (res.code == 200) {
                            let access_token = Storage.localStorageGet("access_token");
                            let data = {
                                ts: new Date().getTime(),
                                cch_id: urlData.pid,
                                app_id: urlData.appid,
                                token: res.data,
                                md_id: urlData.md_id,
                                ad_id: urlData.ukey,
                                time_zone: Base.timeZone(),
                                nonce: Base.nonce(12),
                                version: "1.0",
                                cch_pay_data: "",
                                access_token: access_token,
                                order_amt: payInfo.order_amt,
                                currency: payInfo.currency,
                                app_order_no: payInfo.app_order_no,
                                role_id: payInfo.role_id,
                                role_name: payInfo.role_name,
                                role_level: payInfo.role_level,
                                server_id: payInfo.server_id,
                                server_name: payInfo.server_name,
                                app_subject: payInfo.app_subject,
                                app_ext: payInfo.app_ext || "",
                                order_source: ORDER_SOURCE
                            };
                            data.device_id = Storage.localStorageGet("deviceIdUa");
                            data.sign = RSSign(data, data.app_id);
                            console.log("下单data打印测试更新====", data);

                            SyModel.createOrder(apiUrl.create_order, data).then(
                                (res) => {
                                    console.log("下单返回res===", res);
                                    if (res.code == 200) {
                                        let system = Base.checkSysteam()
                                        // 设置支付系统是pc 或者 wap
                                        let system_type = ''
                                        if(system === 'PC') {
                                            Report.webDotFather(
                                                urlData.pid,
                                                urlData.appid,
                                                urlData.ukey,
                                                "show_pcmsr_pay_index"
                                            );
                                            system_type = 'pc'
                                        } else {
                                            Report.webDotFather(
                                                urlData.pid,
                                                urlData.appid,
                                                urlData.ukey,
                                                "show_momsr_pay_index"
                                            );
                                            system_type = 'wap'
                                        }
                                        console.log("下单返回res.data===", res.data);
                                        // 如果成功了就需要下发一条链接给研发   showTitlebar等于1在移动端会显示标题，否则不显示
                                        let data = res.data.trade_data;
                                        let payUrl =
                                            apiUrl.third_pay +
                                            `?system_type=${system_type}&showTitlebar=1&con_id=${data.con_id}&trade_amt=${data.trade_amt}&mht_trade_no=${data.mht_trade_no}&tm=${data.tm}&uid=${data.uid}&os=${data.os}&subject=${data.subject}&ver=${data.ver}&sign_type=${data.sign_type}&papp_id=${data.papp_id}&app_id=${data.app_id}&cch_id=${data.cch_id}&currency=${data.currency}&access_token=${data.access_token}&md_id=${data.md_id}&device_id=${data.device_id}&time_zone=${data.time_zone}&sys_language=${data.sys_language}&area=&app_ext=&role_id=${payInfo.role_id}&server_id=${payInfo.server_id}&pay_company_type=${data.pay_company_type}&order_source=${data.order_source}`;
                                        console.log("支付链接payUrl===", payUrl);
                                        // window.open(payUrl);
                                        // 因为 window.open(payUrl); 在ios终端拉不起支付。所以要做下系统判断再打开支付页面
                                        if (system == 'PC') {
                                            window.open(payUrl);
                                        } else {
                                            console.log('daimaa111')
                                            this.myfunction(payUrl)
                                        }
                                        resolve(payUrl);
                                    }
                                }
                            );
                        }
                    });
            });
        }
    },
    // 角色信息数据上报
    async RaStarUpload(data, urlData, dataCollecInfo) {
        if (!window.Role) {
            window.Role = data.role_info;
        }
        let enter = data.action;
        data.tm = Date.parse(new Date()); //时间戳 秒
        data.cch_id = urlData.pid;
        data.app_id = urlData.appid;
        data.device_id = Storage.localStorageGet("deviceIdUa");
        data.ukey = urlData.ukey;
        data.action = enter;
        data.role_info = JSON.stringify(data.role_info);
        data.uinfo = JSON.stringify(dataCollecInfo);
        data.sdk_ver = Base.sdkVer();
        data.app_ver = "websdk";
        data.app_version_code = "1.0.0";
        data.sign = RSSign(data, data.app_id);
        console.log("打印角色上报所有打他数据", data);
        console.log("打印角色上报data.uinfo===", data.uinfo);
        // 获取了接口地址
        let suc = await SdkModel.RaStarUpload(data);
        if (suc.code == 200) {
            if (data.action == "enter") {
                console.log("角色进入服务器");
            } else if (data.action == "create") {
                console.log("创建游戏角色");
            } else if (data.action == "up_level") {
                console.log("角色升级");
            } else if (data.action == "update") {
                console.log("角色改名");
            } else {
                console.log("角色上报action错误");
            }
            console.log("角色上报成功");
        } else {
            console.log(suc.msg);
        }
    },
}
export default RastarSdk
